var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(this.bannerclass == null || this.bannerclass == '')?'innerBannertext':this.bannerclass},[(this.sname != null && this.sname != '')?_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(this.sname))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2ba7aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionBanner.vue
// module id = null
// module chunks = 